/**
 * Compact "Image not available" placeholder for cover swatch tiles.
 */
import React from 'react';
import PropTypes from 'prop-types';

import ImageNotAvailable from '@amblique/king-living/app/components/image-not-available';

const CoverSwatchImageNotAvailable = ({wrapperProps, svgProps}) => (
  <ImageNotAvailable
    svgProps={{
      height: '100%',
      maxHeight: '100%',
      maxWidth: '100%',
      width: '100%',
      ...svgProps,
    }}
    wrapperProps={{
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      overflow: 'hidden',
      width: '100%',
      ...wrapperProps,
    }}
  />
);

CoverSwatchImageNotAvailable.propTypes = {
  svgProps: PropTypes.object,
  wrapperProps: PropTypes.object,
};

export default CoverSwatchImageNotAvailable;
